import { Importance } from "PFCore/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useImportanceLabelMap = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      [Importance.Supporting]: t("importance.supporting"),
      [Importance.Essential]: t("importance.essential"),
      [Importance.Required]: t("importance.hardFilter")
    }),
    [t]
  );
};
